import React, { useState } from 'react';
import { Image, Row } from 'react-bootstrap';

import SideMenu from './SideMenu';
import { ContactUsModal } from './contactUs/ContactUsModal';

import menuIcon from '../../assets/sideMenu/burger-menu.svg';
import { CONTACT_US_STEPS } from './contactUs/contactUs.constants';
import { AddAPetModal } from '../myPets/AddAPetModal';

export const SideAndBurgerMenu = ({
  contactUsVisible = false,
  modalAddPetVisible = false,
  setContactUsVisible = () => { },
  toggleModalAddPetVisible = () => { },
}) => {
  const [leftMenuOpen, setLeftMenuOpen] = useState(false);

  const toggleSidebar = () => {
    setLeftMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    if (leftMenuOpen) {
      setLeftMenuOpen(false);
    }
  };

  const onContactUsClose = () => {
    setContactUsVisible(false);
  };

  return (
    <>
      <div id="left">
        <Image
          className={'Side-menu-burger-icon'
                    + `${leftMenuOpen ? ' Side-menu-burger-open' : ''}`}
          onClick={toggleSidebar}
          src={menuIcon}
        />

        <div className={`sidebar ${leftMenuOpen ? 'open' : 'closed'} Sidebar`}>
          <div className="content">
            <SideMenu
              onMenuItemPress={closeMenu}
              setContactUsVisible={setContactUsVisible}
              toggleModalAddPetVisible={toggleModalAddPetVisible}
            />
          </div>
        </div>
      </div>

      <AddAPetModal
        modalAddPetVisible={modalAddPetVisible}
        onCloseModalAddPet={toggleModalAddPetVisible}
      />

      <ContactUsModal
        companyStep={CONTACT_US_STEPS.HOME}
        onClose={onContactUsClose}
        show={contactUsVisible}
      />

      <Row
        className="Sidebar-overlay"
        hidden={!leftMenuOpen}
        onClick={toggleSidebar}
      />
    </>
  );
};
